import Dexie from "dexie";

const db = new Dexie("artemisdb-training");
db.version(1).stores({
  trainings: "id",
});

export { db };
